<template>
  <div v-loading="loading">
    <PlusPlatformLayout
      :menu-routes="menuRoutes"
      :default-active="defaultActive"
    >
      <template v-slot:sider-hd>
        <el-tooltip :content="'课程:' + projectName" placement="right">
          <div class="project-sider-header">{{ projectName }}</div>
        </el-tooltip>
      </template>
      <template v-slot:content-header-middle>
        <div class="project-header-middle">{{ template.title }}</div>
      </template>
      <template v-slot:content-mainer>
        <div class="project-content-body">
          <section v-for="item in template.contents" :key="item.id">
            <!-- 富文本 -->
            <div class="project-content" v-if="item.type === 'text'">
              <markdown-it :md="item.content.html"></markdown-it>
            </div>

            <!-- 一问一答 -->
            <div class="project-content">
              <ProjectQA
                v-if="item.type === 'question'"
                :id="item.id"
                :source-id="$route.params.pathId"
                :project-id="$route.params.projectId"
                :title="item.content.title"
                :description="item.content.desc"
                :buttons="item.content.button"
                :button-active-index="item.content.mainButton"
              />
            </div>

            <!-- 点评 -->
            <div class="project-content">
              <ProjectComment
                v-if="item.type === 'evaluate'"
                :id="item.id"
                :source-id="$route.params.pathId"
                :project-id="$route.params.projectId"
                :title="item.content.title"
                :description="item.content.desc"
                :selectOptions="item.content.commentArr"
              />
            </div>

            <!-- 打卡 -->
            <ProjectClockIn
              class="project-content"
              v-if="item.type === 'punch_card'"
              :id="item.id"
              :source-id="Number($route.params.pathId)"
              :project-id="Number($route.params.projectId)"
              :title="item.content.title"
              :description="item.content.description"
            />

            <!-- 作业 -->
            <div class="project-content">
              <ProjectHomework
                v-if="item.type === 'homework'"
                :id="item.id"
                :source-id="$route.params.pathId"
                :project-id="$route.params.projectId"
              />
            </div>
          </section>
        </div>
      </template>
    </PlusPlatformLayout>
  </div>
</template>

<script>
import PlusPlatformLayout from "@/components/PlusPlatformLayout.vue";
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
import ProjectQA from "@/components/ProjectQA.vue";
import ProjectComment from "@/components/ProjectComment.vue";
import ProjectClockIn from "@/components/ProjectClockIn.vue";
import ProjectHomework from "@/components/ProjectHomework.vue";
import plusService from "@/global/services/jikerPlus";

export default {
  components: {
    PlusPlatformLayout,
    MarkdownIt,
    ProjectQA,
    ProjectComment,
    ProjectClockIn,
    ProjectHomework
  },
  data() {
    return {
      loading: false,
      menuRoutes: [],
      defaultActive: "",
      projectName: "",
      template: {
        title: ""
      }
    };
  },
  created() {
    this.templateId = Number(this.$route.query.template_id) || "";
    this.getData();
  },
  watch: {
    $route() {
      this.templateId = Number(this.$route.query.template_id) || "";
      this.setTemplate();
    }
  },
  methods: {
    getData() {
      const { pathId, projectId } = this.$route.params;
      this.loading = true;
      plusService
        .project(projectId, { source: "kongfu", source_id: pathId })
        .then(res => {
          this.projectName = res.name;
          res.pages.forEach(data => {
            data.title = data.name;
            data.name = "KongfuProject";
            data.params = { pathId, projectId };
            data.query = {
              template_id: data.id
            };
          });
          this.menuRoutes = res.pages;
          this.setTemplate();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setTemplate() {
      const { pathId, projectId } = this.$route.params;
      if (!this.templateId) {
        this.$router.replace({
          name: "KongfuProject",
          params: { pathId, projectId },
          query: {
            template_id: this.menuRoutes[0].id
          }
        });
        return;
      }
      this.defaultActive = `${this.templateId}-`;
      this.menuRoutes.forEach(data => {
        if (data.id === Number(this.templateId)) {
          this.template = data;
        }
      });
    }
  }
};
</script>

<style type="text/css" lang="less" scoped>
.project-sider-header {
  z-index: 2;
  padding: 20px 0;
  height: 60px;
  line-height: 20px;
  font-size: 14px;
  color: #fff;
  text-indent: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-shadow: 0 2px 6px 0 rgba(21, 21, 21, 0.45);
  cursor: pointer;
}
.project-header-middle {
  text-align: center;
}
.project-content-mainer {
  margin: 0 auto;
  padding: 60px 48px;
  max-width: 900px;
}
.project-content-body {
  height: 100%;
  text-align: center;
  .project-content {
    display: inline-block;
    width: 900px;
    text-align: left;
  }
}
</style>
